import React from 'react';
import PropTypes from 'prop-types';
import VideoArrays from './Images/VideoArrays.js';
import Typography from '@material-ui/core/Typography';

export default function GoatVideos(props) {
	const {nickName} = props;
    return (VideoArrays[nickName] ? 
	<div>
	<Typography variant="h6">{`Videos of ${nickName}`}</Typography>{
	VideoArrays[nickName].map ((video) => (
		<video key={video.description} width="300" height="300" controls>
		  <source src={video.video} type="video/mp4">
			</source>
		</video>
	))}
	</div>
	: <div></div>);
};

GoatVideos.propTypes = {
	nickName: PropTypes.string.isRequired
};